import React, { useRef } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import styles from 'react/user/components/auth_modal.module.scss';
import Clickable from '@/components/Clickable';

const ModalForm = props => {
  const el = useRef(null);

  function handleClick(e) {
    if (e.target == el.current) props.closeModal(e);
  }

  if (props.isOpen === false) return null;

  return ReactDOM.createPortal(
    <div className="modal-container" onClick={handleClick} ref={el}>
      <div className={classNames('modal', props.className)}>
        {!props.noTitle && (
          <div className="modal-title">
            <h3>{props.title}</h3>
            {props.closeModal && (
              <Clickable className="cursor" onClick={props.closeModal}>
                <i className={styles.closeIcon} />
              </Clickable>
            )}
          </div>
        )}
        <div className="modal-content">{props.children}</div>
      </div>
    </div>,
    document.body
  );
};

ModalForm.propTypes = {
  isOpen: PropTypes.bool,
  noTitle: PropTypes.bool,
  title: PropTypes.string,
  closeModal: PropTypes.func,
  children: PropTypes.element,
  className: PropTypes.string
};

export default ModalForm;
